import _ from 'lodash';
import moment from 'moment';
import * as types from '../../constants/actionTypes';
import * as storeKeys from '../../constants/storeKeys';
import {firebase} from '../../firebase'

function requestUserTasks() {
  return {
    type: types.REQUEST_USER_TASKS
  }
}

function receiveUserTasks(userTasks) {
  return {
    type: types.RECEIVE_USER_TASKS,
    users: userTasks
  }
}

function receiveSpecificUserTasks(uid, userTasks) {
  return {
    type: types.RECEIVE_SPECIFIC_USER_TASKS,
    user: userTasks,
    uid: uid
  }
}

function appendHiddenUid(uid) {
  return {
    type: types.APPEND_HIDDEN_UID,
    uid: uid
  }
}

function removeHiddenUid(uid) {
  return {
    type: types.REMOVE_HIDDEN_UID,
    uid: uid
  }
}

export function fetchMyUserTasks(startMoment, endMoment) {
  const uid = firebase.auth().currentUser.uid;
  return fetchSpecificUserTasks(uid, startMoment, endMoment);
}

function fetchSpecificUserTasks(uid, startMoment, endMoment) {
  const path = `users/${uid}`;
  return fetchUserTasksWithPath(path, startMoment, endMoment);
}

export function fetchUserTasks(startMoment, endMoment) {
  return fetchUserTasksWithPath('users', startMoment, endMoment);
}

export function fetchUserTasksWithPath(path, startMoment, endMoment) {
  return dispatch => {
    dispatch(requestUserTasks());

    return firebase.database().ref(path).once('value').then(function(snapshot) {
      let receivedUsers = snapshot.val();
      if (_.indexOf(_.keys(receivedUsers), 'uid') >= 0) {
        let newReceivedUsers = {};
        newReceivedUsers[receivedUsers.uid] = receivedUsers;
        receivedUsers = newReceivedUsers;
      }
      let users = _.toPairs(receivedUsers).map((p) => {
        return p[1];
      });
      const to = moment(endMoment.toDate()).utc().format();
      firebase.database().ref('tasks').orderByChild("startAt").endAt(to).once('value').then(function(tSnapshot) {
        const taskKeys = _.toPairs(tSnapshot.val()).map((p) => {
          return p[0];
        });
        firebase.database().ref('user-tasks').once('value').then(function(uSnapshot) {
          //TODO:
          //move to businessLogic
          let tasks = uSnapshot.val();
          if (_.isEmpty(tasks)) {
            tasks = [];
          }

          _.each(users, function(u) {
            let uTasks = [];
            if (tasks[u.uid]) {
              uTasks = tasks[u.uid].tasks;
            }
            u['tasks'] = _.toPairs(uTasks).map((p) => {
              let ut = p[1];
              ut['key'] = p[0];
              return (_.includes(taskKeys, p[0]) && moment(p[1].endAt) >= startMoment) ? ut : null;
            });
            u['tasks'] = _.compact(u['tasks']);
            let dailyHours = [];
            let m = moment(startMoment.toDate());
            while (m <= endMoment) {
              dailyHours[`d${m.format('MM')}${m.format('DD')}`] = 0;
              m.add(1, 'day');
            }
            _.each(u['tasks'], (t) => {
              let mm = moment(t.startAt);
              const end = moment(t.endAt);
              while (mm <= end) {
                if (mm >= startMoment && mm <= endMoment) {
                  const k = `d${mm.format('MM')}${mm.format('DD')}`;
                  dailyHours[k] = dailyHours[k] + parseInt(t.hours, 10);
                }
                mm.add(1, 'day');
              }
            });
            u['dailyHours'] = dailyHours;
            //DEBUG:
            //console.log(dailyHours);
            //console.table(u.tasks)
          });
          if (path === 'users') {
            dispatch(receiveUserTasks(users));
          } else {
            dispatch(receiveSpecificUserTasks(path.replace('users/', ''), users[0]));
          }
        });
      });
    });
  }
}

export function appendHiddenUidIfNeeded(uid) {
  return (dispatch, getState) => {
    if (_.indexOf(getState().userTask.hiddenUids, uid) < 0) {
      let uids = localStorage.getItem(storeKeys.HIDDEN_USER_UIDS);
      if (uids) {
        uids = JSON.parse(uids);
      } else {
        uids = [];
      }
      uids.push(uid);
      localStorage.setItem(storeKeys.HIDDEN_USER_UIDS, JSON.stringify(uids));

      dispatch(appendHiddenUid(uid));
    }
  }
}

export function removeHiddenUidIfNeeded(uid) {
  return (dispatch, getState) => {
    //TODO: this logic is duplicated with reducer
    let uids = getState().userTask.hiddenUids;
    const idx = _.indexOf(uids, uid);
    if (idx >= 0) {
      uids = [
        ...uids.slice(0, idx),
        ...uids.slice(idx + 1)
      ];
      localStorage.setItem(storeKeys.HIDDEN_USER_UIDS, JSON.stringify(uids));

      dispatch(removeHiddenUid(uid));
    }
  }
}

export function restoreHiddenUids() {
  let uids = localStorage.getItem(storeKeys.HIDDEN_USER_UIDS);
  if (uids) {
    uids = JSON.parse(uids);
  } else {
    uids = [];
  }
  return {
    type: types.RESTORE_HIDDEN_UIDS,
    uids: uids
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/user-task/index.js
 **/